module.exports = __webpack_public_path__ + "media/images/communities/logos/ao10-c3ab732024c7ab42219e87fd64d531b5.png";